module.exports = __webpack_public_path__ + "static/media/pizza-express.a1205279.jpg";